import { css } from "@emotion/css";
import { ExternalLink } from "@octopusdeploy/design-system-components";
import { space } from "@octopusdeploy/design-system-tokens";
import { YouTubePlayer } from "~/components/ContextualHelpLayout/YouTubePlayer";
import { Note } from "~/components/form";
import { LearnMoreResources, OverviewContainer, OverviewHighlightText, TermsText, TopicsContainer } from "../../CommonComponents/CommonViews";
const bulletStyle = css({
    listStyleType: "disc",
    listStylePosition: "inside",
    margin: `0 0 0 ${space[12]}`,
    color: "inherit",
});
const linksStackStyle = css({
    display: "flex",
    flexDirection: "column",
});
export const ApplicationLiveStatusOverview = () => (<OverviewContainer>
        <OverviewHighlightText>
            <YouTubePlayer videoId="HC7AXz9-ceg"/>
            <p>
                <ExternalLink href="live-object-status">Kubernetes Live Object Status</ExternalLink> shows the real-time state of your Kubernetes objects after deployment. It helps you monitor and troubleshoot your applications all in one place.
            </p>
            <br />
            <p>Octopus shows the sync and health status for each object and a status summary for the entire application.</p>
        </OverviewHighlightText>
        <TermsText>
            <Note heading={"How to get detailed object information"}/>
            <Note>
                Select an object on the live status page to view:
                <ul className={bulletStyle}>
                    <li>Events</li>
                    <li>Logs</li>
                    <li>Applied manifests</li>
                    <li>Diffs between applied and live manifests</li>
                </ul>
            </Note>
        </TermsText>
    </OverviewContainer>);
export const ApplicationLiveStatusTopics = () => (<TopicsContainer>
        <LearnMoreResources>
            <div className={linksStackStyle}>
                <ExternalLink href="kubernetesagent">Kubernetes Agent</ExternalLink>
                <ExternalLink href="kubernetes-monitor">Kubernetes Monitor</ExternalLink>
                <ExternalLink href="kubernetes-monitor-installation-help">Troubleshoot Kubernetes Live Object Status</ExternalLink>
                <ExternalLink href="applied-manifest-diffs">Applied Manifest Diffs</ExternalLink>
            </div>
        </LearnMoreResources>
    </TopicsContainer>);
